// Nextsj blog
import React, { Fragment, useEffect } from 'react';
import { createClient } from '../../prismicio';
import { ThemeProvider } from 'styled-components';
import Head from 'next/head';
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { saasModernTheme } from 'common/theme/saasModern';
import ResetCSS from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasModern/sassModern.style';
import Navbar from 'containers/SaasModern/Navbar';
import Footer from 'containers/SaasModern/Footer';
import { Mixpanel } from 'utils/mixpanel';
import AllBlogs from 'containers/SaasModern/Blog/AllBlogs';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';

export default function Blogs({ data, data_main, articleTags,promotion, locale }) {
  useEffect(() => {
    Mixpanel.track('Blog view', {
      'Blog title': 'Blog',
    });
  }, []);
  return (
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <Head>
          <title>Swiftask - Blog</title>
          <meta name="theme-color" content="#ec5555" />
          <link
            href="https://fonts.googleapis.com/css?family=Roboto:300,400,400i,500,500i,700,900|Open+Sans:400,400i,600,700"
            rel="stylesheet"
          />
        </Head>

        <ResetCSS />
        <GlobalStyle />

        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar locale={locale} promotion={promotion}/>
            </DrawerProvider>
          </Sticky>

          <AllBlogs
            data={data}
            data_main={data_main}
            articleTags={articleTags}
          />

          <Footer locale={locale} />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
}
export const getStaticProps = async ({ locale }) => {
  const client = createClient();
  const prismicLanguage = getPrismicLanguage(locale);

  const data = await client.getAllByType('article', {
    lang: prismicLanguage,
    orderings: [{ field: 'my.article.published_date', direction: 'desc' }],
    lang: prismicLanguage,
  });

  const article_tags = await client.getAllByType('article_tags', {
    lang: prismicLanguage,
    orderings: [{ field: 'my.article_tags.title', direction: 'desc' }],
    lang: prismicLanguage,
  });

  const data_main = await client.getSingle('blog_list_main_page', {
    lang: prismicLanguage,
  });

  const sold = await client.getSingle('sold', {
    lang: prismicLanguage,
  });


  return {
    props: {
      promotion: sold.data,
      data,
      locale,
      data_main,
      articleTags: article_tags,
    },
  };
};
